/**
 * Created by glopez on 12/06/17.
 */
import _ from 'lodash';
import {convertFromRead} from '../assets';
import Asset from 'models/asset';

/**
 * Converts request data to get series episodes.
 *
 * @param {number} description - Series description.
 * @returns {Object} Request data.
 */
function convertForGetSeriesEpisodes (description) {

    return {
        filter: {
            'objectType': 'KalturaSearchAssetFilter',
            'kSql': '' +
            '(or series name=\'' + description + '\' ' +
            '(and series-name=\'' + description + '\' ' +
            'present_as_catchup=\'true\'  broadcast_type!=\'Rerun\' end_date<0))',
            'dynamicOrderBy':
                {
                    'objectType': 'KalturaDynamicOrderBy',
                    'name': 'Priority',
                    'orderBy': 'META_DESC'
                }
        },
        pager: {
            'pageSize': 1000,
            'pageIndex': 1
        }
    };
}

/**
 * Prepare the request data to get Series page info.
 *
 * @param {number} seriesId - Series id.
 * @return {Object} Map of requests.
 */
function convertForSeriesPage (seriesId) {
    let requestPayload = {
        id: seriesId,
        assetReferenceType: 'Media'
    };

    return requestPayload;
}

/**
 * Converts read data to linear channels data.
 *
 * @param {Object} response - Response data.
 * @returns {Object} Linear channels data.
 */
function convertFromGetSeriesEpisodes (response) {
    let episodes = [];

    _.forEach(_.get(response, ['objects']), (item) => {
        episodes.push(new Asset(convertFromRead.call(this, item)));
    });

    return episodes;
}

export {
    convertForSeriesPage,
    convertForGetSeriesEpisodes,
    convertFromGetSeriesEpisodes
};


// WEBPACK FOOTER //
// ./src/js/datasources/kaltura/adapters/pages/series.js